"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonapiVariantGroupRepository = void 0;
const jsonapi_1 = require("@groupby/enrich-sdk/resource/variant-group/jsonapi");
const jsonapi = __importStar(require("../../#lib/jsonapi"));
class JsonapiVariantGroupRepository {
    constructor(config, $fetch) {
        const variantGroupMapper = new jsonapi_1.VariantGroupMapper();
        this.deps = { fetch: $fetch, fromResource: variantGroupMapper.toVariantGroup.bind(variantGroupMapper) };
        this.deps$Create = { toResource: variantGroupMapper.toVariantGroupCreationResource.bind(variantGroupMapper), ...this.deps };
        this.deps$Update = { toResource: variantGroupMapper.toVariantGroupUpdateResource.bind(variantGroupMapper), ...this.deps };
        this.requestConfig = { baseUrl: config.host + '/variantGroups', token: config.token };
    }
    /** @inheritDoc */
    async createOne(variantGroup) {
        return jsonapi.createOne(this.requestConfig, this.deps$Create, variantGroup);
    }
    /** @inheritDoc */
    async createMany(variantGroups) {
        return jsonapi.createMany(this.requestConfig, this.deps$Create, variantGroups);
    }
    /** @inheritDoc */
    async getOne(variantGroupId) {
        return jsonapi.getOne(this.requestConfig, this.deps, variantGroupId);
    }
    /** @inheritDoc */
    async getMany(query = {}) {
        return jsonapi.getMany(this.requestConfig, this.deps, query);
    }
    /** @inheritDoc */
    async getPage(query = {}) {
        return jsonapi.getPage(this.requestConfig, this.deps, query);
    }
    /** @inheritDoc */
    async getTotal(criteria) {
        return jsonapi.getTotal(this.requestConfig, this.deps, criteria);
    }
    /** @inheritDoc */
    async updateOne(variantGroup) {
        return jsonapi.updateOne(this.requestConfig, this.deps$Update, variantGroup);
    }
    /** @inheritDoc */
    async updateMany(variantGroups) {
        return jsonapi.updateMany(this.requestConfig, this.deps$Update, variantGroups);
    }
    /** @inheritDoc */
    async deleteOne(variantGroupId) {
        return jsonapi.deleteOne(this.requestConfig, this.deps, variantGroupId);
    }
    /** @inheritDoc */
    async deleteMany(criteria) {
        return jsonapi.deleteMany(this.requestConfig, this.deps, criteria);
    }
}
exports.JsonapiVariantGroupRepository = JsonapiVariantGroupRepository;
//# sourceMappingURL=#jsonapi-variant-group-repository.js.map